module.exports = __webpack_public_path__ + "img/theme.0d6b5d8b.png";